import { combineReducers } from 'redux';

import * as types from 'modules/chat/actionTypes';
import customerConversationValidity from 'modules/chat/reducer/ui/CreateModal/customerConversationValidity';
import error from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';

import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  mode: string,
 *  apiError: string,
 *  isLoading: boolean,
 *  isVisible: boolean,
 *  customerConversationValidity: import("modules/chat/reducer/ui/CreateModal/customerConversationValidity").CustomerConversationValidityReducer,
 * }} ChatUiModalCreateReducer
 */

export default combineReducers({
  customerConversationValidity,
  apiError: error(types.POST_CONVERSATION),
  isLoading: loading(types.POST_CONVERSATION),
  mode: createReducer(null, {
    [types.OPEN_CREATE_CONVERSATION_MODAL]: (_, { payload }) => payload.mode,
    [types.CLOSE_CREATE_CONVERSATION_MODAL]: () => null,
    [types.POST_CONVERSATION_SUCCESS]: () => null,
  }),
  isVisible: createReducer(false, {
    [types.OPEN_CREATE_CONVERSATION_MODAL]: () => true,
    [types.CLOSE_CREATE_CONVERSATION_MODAL]: () => false,
    [types.POST_CONVERSATION_SUCCESS]: () => false,
  }),
});
